import Index from './index.vue'

export default {
  name: 'aiTalentRecommendedList',
  path: '/v-admin/ai-talent-recommendation/job/:jobId/candidate/',
  component: Index,
  meta: {
    permission: ['PREMIUM_AI_TALENT_RECOMMENDED'],
    isInclude: true,
    titleI18nKey: 'admin.application.applicantList.title.aiRecommendedList'
  }
}
